import { Currency, PayerPayrollSettings } from "@wingspanhq/wingspan-api-sdk";

/**
 * The currencies this payer can run contractor payroll in, in a stable order.
 *
 * `fundingSourcesByCurrency` is the authority — a currency with no funding
 * source behind it cannot be funded, whatever the payables are denominated in.
 * A payer with only `defaultFundingSource` set runs a single currency, and the
 * screen shows no picker.
 */
export const selectorPayrollFundingCurrencies = (
  payrollSettings?: PayerPayrollSettings
): Currency[] =>
  Object.keys(payrollSettings?.fundingSourcesByCurrency ?? {})
    .sort()
    .filter((currency): currency is Currency =>
      Object.values(Currency).includes(currency as Currency)
    );
